export * from './messages'

export const USER_ROLES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  USER: 3
}
